module.exports = "bundles/433163f438fb7bea90dd3846622c0fc0.png";


//////////////////
// WEBPACK FOOTER
// ../src/media/remove.png
// module id = 142
// module chunks = 0